import React, { useState } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useTranslation } from 'react-i18next';

import ButtonComponent from './ButtonComponent.jsx';
import GoogleLogInLink from './GoogleLogInLink.jsx';
import { isValidEmail } from './UserUtility.jsx';

function Login(props){
  const { t, i18n } = useTranslation();
  const [username,setUsername] = useState('');
  const [password,setPassword] = useState('');
  const [usernameError,setUsernameError] = useState();
  const [passwordError,setPasswordError] = useState();
  const [loading,setLoading] = useState(false);
  const {executeRecaptcha} = useGoogleReCaptcha();

  const onLogin = e =>{
    if(!username) setUsernameError("Email is required");
    else if (!isValidEmail(username)) setUsernameError("Email is incorrect format");
    else if(!password) setPasswordError("Password is required");
    else {
      setLoading(true);
      executeRecaptcha('login').then(token=>fetch('/user/login', {
        method: 'post',
        headers:{'Content-Type':"application/x-www-form-urlencoded"},
        credentials: 'same-origin',
        body: `username=${username}&password=${password}&reCaptcha=${token}`
      }).then(response => {
        if(response.ok) {
          if (response.redirected) window.location.href = response.url;
          else window.location.href = "/";
        }
        else response.text().then(text=>alert(text));
      }).finally(()=>setLoading(false))).catch(err=>{
        alert(err);
        setLoading(false);
      });
    }
  }

  return <div className='d-flex flex-column justify-content-center align-items-center' style={{height:"100%",backgroundImage:`url("/images/login_background.jpg")`,backgroundSize:'100% 100%'}}>
    <div className='d-flex flex-column align-items-center justify-content-center flex-grow-1' style={{width:"360px"}}>
      <h2 className='my-4 text-center text-capitalize' style={{fontWeight:"bold",color:"var(--vc-darkblue)"}}>{t("login")}</h2>
      <div className={`mb-3 d-flex align-items-center justify-content-between input-group form-control border`} >
        <input type="email" className="border-0 flex-grow-1" placeholder="Email" style={{height:"45px",outline:"none"}} value={username} onChange={e=>{setUsername(e.target.value);setUsernameError('')}}
          onKeyDown={e=>{if(e.key === "Enter") onLogin(e)}} />
        <span className="material-symbols-outlined">mail</span>
      </div>
      {usernameError && <p className='d-flex align-items-center' style={{color:"red",width:"100%"}}>
        <span className="material-symbols-outlined me-1" style={{color:"red"}}>error</span>
          {t(usernameError)}
      </p>}
      <div className={`mb-3 d-flex align-items-center justify-content-between input-group border form-control border`}>
        <input type="password" className="border-0 flex-grow-1" value={password} onChange={e=>{setPassword(e.target.value);setPasswordError('')}} placeholder={t("Password")} style={{height:"45px",outline:"none"}} 
          onKeyDown={e=>{if(e.key === "Enter") onLogin(e)}}/>
        <span className="material-symbols-outlined">password</span>
      </div>
      {passwordError && <p className='d-flex align-items-center' style={{color:"red",width:"100%"}}>
        <span className="material-symbols-outlined me-1" style={{color:"red"}}>error</span>
        {t(passwordError)}
      </p>}
      <div className='d-flex justify-content-end mb-4 text-capitalize' style={{width:'100%'}}>
        <a href="/user/ResetPassword">{t("forgot")} {t("Password")}?</a>
      </div>
      {loading?<div className='spinner-grow'></div>:
        <ButtonComponent onClick={onLogin} label={t("login")}/>
      }
      <div className='mt-3 d-flex align-items-center justify-content-center'>
          <hr style={{width:"140px"}}/>
          <span className='mx-3 text-uppercase'>{t("or")}</span>
          <hr style={{width:"140px"}}/>
      </div>
      <GoogleLogInLink />
      <div className='mt-3 d-flex flex-row justify-content-end w-100'>
        <span className='me-1'>{t("Don't have an account")}?</span>
        <a href="/user/Registration" className="text-capitalize">{t("register")}</a>
      </div>
    </div>
  </div>
}

export default Login;